import styled from 'styled-components';
import { Colors } from '../../theme';
import { breakpointLG, breakpointMD, breakpointSM } from './styles/breakpoints';
import { HEADER_TYPE } from './types';
export const Wrapper = styled.div `
  position: relative;
  box-sizing: border-box;
  padding-bottom: ${({ $addPadding }) => ($addPadding ? '88px' : 0)};
  background-color: ${Colors.background};

  @media (min-width: ${breakpointMD}) {
    padding-bottom: ${({ $addPadding }) => ($addPadding ? '64px' : 0)};
  }

  @media (min-width: ${breakpointLG}) {
    padding-bottom: ${({ $addPadding }) => ($addPadding ? '72px' : 0)};
  }
`;
export const Container = styled.div `
  position: relative;
  box-sizing: border-box;
  background-color: ${Colors.white};

  &.navWrapper::after {
    position: absolute;
    top: 64px;
    right: 0;
    left: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    width: 100%;
    height: 1px;
    content: '';
    background: ${Colors.cream100};
  }

  @media (min-width: ${breakpointSM}) {
    &.navWrapper::after {
      top: 80px;
    }
  }

  @media (min-width: ${breakpointLG}) {
    padding: 0 24px;
  }
`;
export const CustomHeader = styled.header `
  position: relative;
  max-width: 1320px;
  height: 100%;
  margin: 0 auto;
`;
export const SectionWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: ${({ $type, $hasDataSource }) => $type === HEADER_TYPE.Private || !$hasDataSource ? 'space-between' : 'flex-start'};
`;
export const TopNav = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 64px;
  padding: 0 16px;

  @media (min-width: ${breakpointSM}) {
    min-height: 80px;
    padding: 0 24px;
  }

  @media (min-width: ${breakpointLG}) {
    justify-content: space-between;
    padding: 0 24px;
  }
`;
//# sourceMappingURL=styles.js.map